import React from 'react';
import {View} from 'react-native';
import {
  Button,
  Divider,
  Icon,
  IconButton,
  List,
  useTheme,
} from 'react-native-paper';
import {useMutation, useQuery} from 'react-query';
import {SettingsAvatar} from '../settings/avatar';
import {getById} from '../../api';
import {
  connectToExchangeService,
  connectToExchangeToken,
  uniSwapLink,
} from '../../api/exchange';
import {IShopConfig} from '../../types/shop';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setAppDialogParams} from '../../store/slices/ui';
import {useCloseDialog} from '../../hooks/useCloseDialog';
import {PayoutDialogBody} from './payoutdialogbody';
import {ERC20__factory} from '../../api/typechain-types';
import {signer} from '../../api/metamask';
import * as ethers from 'ethers';
export const Payouts = ({shopId}: {shopId: string}) => {
  const shopDataQuery = useQuery('payouts_' + shopId, async () => {
    const shop = (await getById(shopId)) as IShopConfig;
    console.info('found shop', shop);
    if (!shop.address) return shop;
    const contract = await connectToExchangeService(shop.address);
    const exdc = await connectToExchangeToken();
    const coin = await contract.wp();
    const sig = await signer();
    const erc20 = new ethers.Contract(coin, ERC20__factory.abi, sig);
    return {
      shop,
      excdBalance: ethers.formatUnits(
        await exdc.balanceOf(shop.address),
        await exdc.decimals(),
      ),
      balance: ethers.formatUnits(
        await contract.balanceOfContract(),
        await erc20.decimals(),
      ),
    };
  });
  const bid = useAppSelector(state => state.auction.bidAmount);
  const wallet = useAppSelector(state => state.auction.bidWallet);
  const dispatch = useAppDispatch();
  const {closeDialog} = useCloseDialog();
  const shopData = shopDataQuery.data;
  const shopAddress = shopData?.shop?.address;
  const payoutMutation = useMutation(async () => {
    console.info('bid, wallet', bid, wallet, shopAddress);
    const contract = await connectToExchangeService(shopAddress);
    if (!bid || !wallet) throw 'no_data';

    await contract.removeLiquidity(bid, wallet);
  });
  const openPayoutDialog = () => {
    dispatch(
      setAppDialogParams({
        appDialogVisible: true,
        appDialogTitle: `Request Payout to Account`,
        appDialogIcon: 'currency-usd',
        appDialogOnSelectRight: async () => {
          await payoutMutation.mutateAsync();
          closeDialog();
        },
        appDialogOnSelectLeftt: undefined,
        appDialogBody: PayoutDialogBody,
        appDialogControls: undefined,
        appDialogLoading: payoutMutation.isLoading,
      }),
    );
  };
  const theme = useTheme();
  return (
    <View>
      <List.Item
        theme={theme}
        title={() => (
          <List.Section>
            <List.Item title={'Shop Wallet:'} />
            <List.Item title={shopAddress} />
            <Divider />
          </List.Section>
        )}
        style={{height: 'auto'}}
        left={() => <IconButton icon={'cash'} />}
        description={() => (
          <List.Section>
            <List.Item
              left={() => <List.Icon icon={'wallet'} />}
              title={'EXDC: ' + (shopData?.excdBalance || 0)}
              right={() => (
                <Button
                  icon={'cash-plus'}
                  mode="outlined"
                  onPress={() => window.open(uniSwapLink, '_blank')}>
                  Buy/Sell
                </Button>
              )}
            />
            <List.Item
              left={() => <List.Icon icon={'wallet'} />}
              title={'Revenue: ' + (shopData?.balance || 0)}
              right={() => (
                <Button
                  icon={'cash-minus'}
                  mode="outlined"
                  onPress={() => openPayoutDialog()}>
                  Withdraw
                </Button>
              )}
            />
          </List.Section>
        )}
      />
    </View>
  );
};
